import React from 'react';

import { Row, Col } from 'components/bootstrap';
import { DocumentTitle, PageHeader } from 'components/common';

import DataLakeConnectorsList from './DataLakeConnectorsList';

const DataLakeConnectorsPage = () => (
  <DocumentTitle title="Data Lake Connectors">
    <PageHeader title="Data Lake Connectors">
      <span>
        <p>
          Connectors to external data lakes may be added and managed from this page. Each connector is associated with a
          system managed stream to which data retrieved from an external data lake can be stored.
        </p>
        <p>
          Data Lakes with connectors may be explored using the Data Lake {'>'} Preview feature, from where a selective
          Data Lake Retrieval task may also be launched.
        </p>
        <p>
          Data Lake Connectors also facilitate the use the Filtered Inputs, which can continually ingest new data that
          meets the selected filter criteria from the target external data lake. These are also created from the Data
          Lake {'>'} Preview page.
        </p>
      </span>
    </PageHeader>
    <Row className="content">
      <Col md={12}>
        <DataLakeConnectorsList />
      </Col>
    </Row>
  </DocumentTitle>
);

export default DataLakeConnectorsPage;
